import React from 'react';
import AccountManagement from './AccountManagement/AccountManagement';

const Profile = () => {
  return <AccountManagement />;
};

export default Profile;
